import {useOrganizationDetailsStore} from '@features/organization-settings/organization-details.store';
import {defineStore, storeToRefs} from 'pinia';
import {computed, ref, useRequestURL} from '#imports';
import {readonlyState} from '@malt/utils';

export const useRedirectParamsStore = defineStore('redirect-params-store', () => {
    const dropRedirect = ref<string | null>();
    const successRedirect = ref<string | null>();
    const {organizationId} = storeToRefs(useOrganizationDetailsStore());

    const defaultRedirect = computed(() => `/client-settings/organization/${organizationId.value}/details`);

    function setRedirectUrl() {
        const currentUrl = useRequestURL();
        const dropRedirectPath = currentUrl.searchParams.get('dropRedirectPath');
        const successRedirectPath = currentUrl.searchParams.get('successRedirectPath');

        dropRedirect.value = dropRedirectPath || defaultRedirect.value;
        successRedirect.value = successRedirectPath || defaultRedirect.value;
    }

    const redirectParams = computed(() => ({
        ...(dropRedirect.value ? {dropRedirectPath: dropRedirect.value} : {}),
        ...(successRedirect.value ? {successRedirectPath: successRedirect.value} : {}),
    }));

    return {
        dropRedirect: readonlyState(dropRedirect),
        successRedirect: readonlyState(successRedirect),
        redirectParams,
        setRedirectUrl,
    };
});
